export const NameMaxLength = 50;
export const EmailMaxLength = 255;
export const LabelMaxLength = 255;
